<template>
    <div class="Record-page">
        <!-- 返回、标题 -->
        <div
            class="Record-page-header"
            :style="{ paddingTop: 25 + statusBarHeight + 'px' }"
        >
            <div class="Record-page-header-return" @click="handleClose">
                <img
                :src="require('@/assets/images/YuliApp/CyberportCoupon/Native_button_return.png')"
                />
            </div>
            <h1 class="Record-page-header-title">Coupon Records</h1>
        </div>
        <!-- 列表页 -->
        <div class="Record-page-listView">
            <div class="Record-page-listView-item" v-for="(item, index) in showList" :key="index">
                <div class="Record-page-listView-item-textBox">
                    <span class="Record-page-listView-item-textBox-label">{{ item?.name }}</span>
                    <span class="Record-page-listView-item-textBox-id">#{{ item?.id }}</span>
                </div>
                <div class="Record-page-listView-item-button">
                    Clipped
                </div>
                <div class="Record-page-listView-item-timeView">
                    {{ formatTimestamp(item?.clipped_at) }}
                </div>
            </div>
            <!-- 无数据缺省 -->
            <div class="Record-page-listView-noData" v-if="showList?.length == 0">
                <img 
                    :src="require('@/assets/images/YuliApp/CyberportCoupon/none.png')" 
                />
                <span>No Coupon available currently</span>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, getCurrentInstance } from "vue";
import { mapState } from "vuex";
import { getUsedTicketList } from "@/api/cyberport.js"
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
props: {
    listData: {
        type: Array,
        default: () => {
            return []
        },
    },
},
watch: {

},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
    }),
},
setup(props, ctx) {
    const {listData} = props;
    const showList = ref([]);
    const { proxy } = getCurrentInstance();
    onMounted(() => {
        firstInit();
        // showList.value = listData?.filter(item => item?.isClip);
    });

    const firstInit = async () => {
        proxy.$loading.show();
        try {
            const res = await getUsedTicketList();
            const { data } = res;
            showList.value = data?.sort((pre,next) => next.clipped_at - pre.clipped_at) || [];
        } catch (error) {
            proxy.$toast.show({
                msg: "NetWork Error",
                type: TOAST_TYPE.ERROR,
            })
        }
        proxy.$loading.hide();
    }

    /**
     * 票点击处理
     */
    const ticketHandle = (ticket) => {
        console.log(ticket);
    }

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        
        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds} UTC +0`;
    }

    /**
     * 处理关闭
     */
     const handleClose = () => {
      ctx.emit("msgHandle", false);
    };

    return {
        handleClose,
        ticketHandle,
        formatTimestamp,
        showList,
    };
},
};
</script>


<style lang="less">
    .Record-page{
        width: 100vw;
        height: 100vh;
        position: fixed;
        background: #718FAB;
        z-index: 999;
        top: 0;
        left: 0;
        &-header {
            position: relative;
            // bottom: 50px;
            width: 100%;
            height: 45px;
            display: flex;
            align-items: center;
            &-return {
                width: 64.07px;
                height: 30px;
                text-align: left;
                // margin-bottom: 18px;
                img {
                    width: 100%;
                    height: 100%;
                    margin-left: -4px;
                }
            }
            &-title {
                // padding-top: 15px;
                margin-left: calc((100vw / 2) - 64.07px);
                transform: translateX(-50%);
                color: rgba(255, 255, 255, 1);
                font-size: 16px;
                font-weight: 500;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 30px;
            }
        }
        &-listView{
            width: 100%;
            height: 100%;
            padding: 9px;
            padding-bottom: 90px;
            overflow: scroll;
            box-sizing: border-box;
            &-item{
                width: 357px;
                height: 94px;
                background: url("~@/assets/images/YuliApp/CyberportCoupon/had_checked_item.png")
                no-repeat top left;
                background-size: 100% 100%;
                margin: 0 auto;
                margin-bottom: 8px;
                padding: 11px 25px 0 27px;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                position: relative;
                &-textBox{
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    font-family: "PingFang SC";
                    text-align: left;
                    &-label{
                        color: #434a4f;
                        font-size: 15px;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }
                    &-id{
                        color: #26313c;
                        font-size: 22px;
                        font-weight: 600;
                    }
                }
                &-button{
                    width: 88px;
                    height: 26px;
                    border-radius: 4px;
                    background: #4fa361;
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: 500;
                    font-family: "PingFang SC";
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                &-timeView{
                    position: absolute;
                    bottom: 5px;
                    right: 11px;
                    width: fit-content;
                    height: 16px;
                    color: #00000080;
                    font-size: 11px;
                    font-weight: 400;
                    font-family: "PingFang SC";
                    text-align: right;
                    line-height: 16px;
                }
            }
            &-noData{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                margin-top: 50%;
                img{
                    width: 100px;
                    height: 100px;
                    margin-bottom: 20px;
                }
                span{
                    color: #ffffff;
                    font-size: 18px;
                    font-weight: 500;
                    font-family: "PingFang HK";
                    text-align: center;
                }
            }
        }
    }
</style>